/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Col_ItemsInputs */

const vi_sl_note_col_items = /** @type {(inputs: Sl_Note_Col_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lô`)
};

/**

* @param {Sl_Note_Col_ItemsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_col_items = /** @type {((inputs?: Sl_Note_Col_ItemsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Col_ItemsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_col_items(inputs)
});